/**
 * Escritas da página de Orçamento pelos repositórios do app: criar, editar e excluir um teto de
 * gasto ou meta de receita, com categorias, origens, recorte e limites por subcategoria.
 */
import { createBudget, deleteBudget, updateBudget } from '@/db/repositories/budgetRepository';
import type { BudgetFormInput, BudgetsEditor } from '../viewer/lib/editing';

function toInput(input: BudgetFormInput) {
  const income = input.type === 'income';
  return {
    name: input.name, icon: input.icon, color: input.color, amount: input.amount, type: input.type,
    period: input.period, cycleStartDay: input.cycleStartDay, cycleAnchorDate: input.cycleAnchorDate,
    categoryIds: input.categoryIds, origins: input.origins,
    // Só teto de gasto tem recorte e limite por subcategoria (ADR 0067/0110).
    subcategoryIds: income ? [] : input.subcategoryIds,
    subcategoryLimits: income ? [] : input.subcategoryLimits,
  };
}

export function createBudgetsEditor(after: () => Promise<void>): BudgetsEditor {
  return {
    async create(input) { const b = await createBudget(toInput(input)); await after(); return b.id; },
    async update(id, input) { await updateBudget(id, toInput(input)); await after(); },
    async remove(id) { await deleteBudget(id); await after(); },
  };
}
